// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useHandlerMyScreenerTable } from '@advisor-app/features/my-research/hooks/use-handler-my-screener-table';
import { WrapperEffect } from '@advisor-app/features/ui/wrapper-effect';
import { CircularProgress, Tooltip } from '@mui/material';
import { IconButton, SectionContainer } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import { ScreenersTable } from './screeners-table';

export const Screeners: FC<{ onSelectScreener: VoidFunction }> = ({
  onSelectScreener,
}) => {
  const { t } = useTranslation('research');
  const {
    dataScreenersTable,
    handleDeleteScreener,
    loadScreener,
    isLoadingScreeners,
    onDownloadScreener,
    isDownloading,
  } = useHandlerMyScreenerTable('screener');

  return (
    <SectionContainer
      title={<Translation i18nKey="research.screeners" ns="research" />}
      popupName="my-research.screeners"
      tooltip
      actions={
        <Tooltip title={t('research.download-screeners', { ns: 'research' })}>
          {isDownloading ? (
            <CircularProgress size={20} color="primary" />
          ) : (
            <IconButton
              icon="Download"
              variant="button"
              onClick={() => onDownloadScreener(dataScreenersTable)}
            />
          )}
        </Tooltip>
      }
    >
      <WrapperEffect showIn={!isLoadingScreeners}>
        <ScreenersTable
          data={dataScreenersTable}
          onDeleteScreener={handleDeleteScreener}
          onLoadScreener={loadScreener(onSelectScreener)}
          onDownloadScreener={onDownloadScreener}
        />
      </WrapperEffect>
    </SectionContainer>
  );
};
